/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Shared_Banner_DescriptionInputs */



/**
* | output |
* | --- |
* | "This chat is shared. Sending a message will create your own copy." |
*
* @param {Chat_Shared_Banner_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_shared_banner_description = /** @type {((inputs?: Chat_Shared_Banner_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Shared_Banner_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Chat ist geteilt. Das Senden einer Nachricht erstellt eine eigene Kopie.")
	return /** @type {LocalizedString} */ ("This chat is shared. Sending a message will create your own copy.")
});